const RETIRED_STATUSES = new Set(['canceled', 'replaced', 'cleared'])
const UNFILLED_STAGES = ['idea', 'planned', 'working']

export function isRetiredSetup(project) {
  return ['closed', 'reviewed'].includes(String(project?.stage || '').toLowerCase())
    && !project?.trade_id
    && RETIRED_STATUSES.has(String(project?.setup_status || '').toLowerCase())
}

export async function retireUnfilledSetup(supabase, project, {
  userId,
  brokerCancellationConfirmed = false,
  canceledAt = new Date().toISOString(),
} = {}) {
  if (!project?.id || !userId || project.user_id !== userId || !project.updated_at) {
    throw new Error('Setup identity or version is unavailable. Refresh before canceling.')
  }
  if (!UNFILLED_STAGES.includes(project.stage) || project.trade_id || project.setup_status === 'filled') {
    throw new Error('This setup belongs to an active or completed position and cannot be canceled here.')
  }
  const hasTrackedOrders = Array.isArray(project.schwab_order_ids) && project.schwab_order_ids.length > 0
  if ((hasTrackedOrders || project.stage === 'working' || project.setup_status === 'working') && !brokerCancellationConfirmed) {
    throw new Error('Broker cancellation must be confirmed before retiring this setup.')
  }
  // A single version-checked update closes the setup lifecycle. Retain all
  // prices, sizing, provenance and order references as its historical snapshot.
  const { data, error } = await supabase.from('position_projects')
    .update({ stage: 'closed', setup_status: 'canceled', closed_at: canceledAt, updated_at: canceledAt })
    .eq('id', project.id)
    .eq('user_id', userId)
    .eq('updated_at', project.updated_at)
    .in('stage', UNFILLED_STAGES)
    .select('id')
    .single()
  if (error || data?.id !== project.id) {
    throw new Error('Setup changed or could not be saved. Refresh to reconcile its current state; its history was not cleared.')
  }
  return data
}
